"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _arkReact = require("@dateam/ark-react");
var _FormContext = _interopRequireDefault(require("./FormContext"));
const availableCase = ['lowercase', 'uppercase'];
const FormFile = _ref => {
  let {
    value,
    placeholder,
    className,
    readOnly,
    required,
    icon,
    state,
    onChange,
    onFocus,
    onBlur
  } = _ref;
  const {
    controlId,
    isFocus,
    required: inputIsRequired,
    onBlur: onInputBlur,
    onFocus: onInputFocus,
    onRequiredChange,
    setState
  } = _react.default.useContext(_FormContext.default);
  const [isInvalid, setIsInvalid] = _react.default.useState(false);
  const checkInputValidation = _react.default.useCallback(files => {
    let inputIsInvalid = false;
    if (inputIsRequired && (files == null || files?.length === 0)) {
      inputIsInvalid = true;
    }
    return inputIsInvalid === false;
  }, [inputIsRequired]);
  const onInputChange = _react.default.useCallback(event => {
    let {
      files: inputFiles
    } = event.target;
    const isValid = checkInputValidation(inputFiles);
    const file = inputFiles && inputFiles.length > 0 ? inputFiles[0] : null;
    setIsInvalid(isValid === false);
    onChange?.(file, event);
  }, [onChange, setIsInvalid]);
  const handleInputBlur = _react.default.useCallback(event => {
    onInputBlur?.();
    onBlur?.(event);
  }, [onInputBlur, onBlur]);
  const handleInputFocus = _react.default.useCallback(event => {
    onInputFocus?.();
    onFocus?.(event);
  }, [onInputFocus, onFocus]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "formInputWrapper"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "file",
    id: controlId,
    name: controlId,
    className: (0, _arkReact.concatClassName)('formControl formInput', isInvalid ? 'formControl-invalid' : null, readOnly ? 'formControl-readOnly' : null, className),
    placeholder: placeholder,
    readOnly: readOnly,
    onChange: onInputChange,
    onFocus: handleInputFocus,
    onBlur: handleInputBlur
    // onPaste={handleInputPaste}
  }), icon != null && /*#__PURE__*/_react.default.createElement("div", {
    className: "formInputIcon"
  }, icon));
};
process.env.NODE_ENV !== "production" ? FormFile.propTypes = {
  value: _propTypes.default.string,
  className: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  readOnly: _propTypes.default.bool,
  icon: _propTypes.default.node,
  required: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  state: _propTypes.default.oneOf(['error', 'warning', 'ok'])
} : void 0;
FormFile.defaultProps = {
  value: undefined,
  className: undefined,
  placeholder: undefined,
  readOnly: undefined,
  icon: undefined,
  required: false,
  onChange: undefined,
  onFocus: undefined,
  onBlur: undefined,
  state: 'ok'
};
var _default = exports.default = FormFile;